/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip, Slider, RadioGroup, FormControlLabel, Radio, TextField, InputLabel, Select, MenuItem } from '@mui/material';
import { Save, History, Cancel, Download } from '@mui/icons-material';
import "./CalculationPanel.scss";
import { MapContext } from '../map/MapContextProvider';
import { utils, writeFileXLSX } from 'xlsx';
import supplierHelper from '../helper/supplierHelper';
const defaultVals = {
    color: '#007eb6',
    width: 10,
    altitude: 0,
    algorithm: 'DBSCAN',
    clusterSize: 2,
    radius: 60
};

const algorithmTypes = ['KMEANS', 'DBSCAN', 'OPTICS'];
const radiusTypes = ['60', '100', '150', '>150'];

export default function CalculationPanel(props) {
    const { onSave, onCancel } = props;
    const { map, mapData } = useContext(MapContext);

    const [radius, setRadius] = useState(defaultVals.radius);
    const [radiusRadio, setRadiusRadio] = useState("60");
    const [algorithm, setAlgorithm] = useState(defaultVals.algorithm);
    const [clusterSize, setClusterSize] = useState(defaultVals.clusterSize);
    const [checkDist, setCheckDist] = useState(false);

    const radioGroupRef = useRef(null);

    const suplierFunctions = new supplierHelper();
    const [option, setOption] = useState({
        algorithm: algorithm,
        radius: 0.8673760610824164,
        radiusMile: 60,
        clusterSize: clusterSize
    });

    const handleCancel = () => {
        onCancel();
    };

    const handleOk = () => {
        console.log(option);
        onSave(option);
    };


    const handleSetAlgorithm = (evt) => {
        setOption({ ...option, algorithm: evt.target.value });
        setAlgorithm(evt.target.value);
    };


    const handleRadiusChange = (evt) => {
        let val = parseInt(evt.target.value);
        if (isNaN(val)) val = defaultVals.radius;
        setRadius(evt.target.value);
        let radiusDegree = val / 69.1741479758212;
        console.log(radiusDegree)
        setOption({ ...option, radius: radiusDegree, radiusMile: val });
    }
    const handleRadiusRadioChange = (evt) => {
        let val;

        if (evt.target.value == ">150") {
            val = radius > 150 ? radius : 151;
            setRadiusRadio(evt.target.value);
            setRadius(val);
        }
        else {
            val = parseInt(evt.target.value);
            if (isNaN(val)) val = defaultVals.radius;
            setRadius(evt.target.value);
            if (val > 150)
                setRadiusRadio(">150");
            else
                setRadiusRadio(evt.target.value);
        }

        let radiusDegree = val / 69.1741479758212;
        console.log(radiusDegree)

        setOption({ ...option, radius: radiusDegree, radiusMile: val });
    };

    const handleClusterChange = (evt) => {
        let val = parseInt(evt.target.value);
        if (isNaN(val)) val = defaultVals.clusterSize;

        setOption({ ...option, clusterSize: val });
        setClusterSize(val);
    };

    const handleDistChange = (evt) => {
        let val = evt.target.checked;
        setOption({ ...option, distanceAlgorithm: val });
        setCheckDist(val);
    };



    const downloadSampleFileHandler = (evt) => {

        let dataList = suplierFunctions.getSupplierListByStates(mapData);

        /* generate worksheet from state */
        const ws = utils.json_to_sheet(dataList);
        /* create workbook and append worksheet */
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Data");
        /* export to XLSX */
        writeFileXLSX(wb, "SupplierListByStates.xlsx");
    };

    const downloadDetailedFileHandler = (evt) => {
        let summaryList = suplierFunctions.getSummary(mapData);
        // let groups = suplierFunctions.getGroups();
        // let outsideHubs = suplierFunctions.getOutsideHubs();
        let [masterList,groups,outsideHubs] = suplierFunctions.getMasterList();
        /* generate worksheet from state */
        // const ws = utils.json_to_sheet(summaryList);
        /* create workbook and append worksheet */

        var ws_data = [
            ["Summary", "Count"],
            ["Total Suppliers", summaryList.supplierCount],
            ["State Count", summaryList.stateCount],
        ];

        summaryList.stateList.forEach(element => {
            ws_data.push([element.state, element.count])
        });

        ws_data.push(["Created Hubs", summaryList.hubCount])
        ws_data.push(["Outside Hubs", summaryList.outsideHubCount])

        var wsSummary = utils.aoa_to_sheet(ws_data);

        let wsDetailed = utils.json_to_sheet(masterList);

        const workbook = utils.book_new();

        // const range = utils.decode_range(worksheet1["!ref"]||"A1");

        // utils.sheet_add_aoa(wsSummary, [
        //     [1],                             // <-- Write 1 to cell B3
        //     ,                                // <-- Do nothing in row 4
        //     [/*B5*/, /*C5*/, /*D5*/, "abc"]  // <-- Write "abc" to cell E5
        // ], { origin: "D3" });

        // utils.sheet_add_aoa(worksheet2, [
        //     ["first row after data", 1],
        //     ["second row after data", 2]
        // ], { origin: -1 });

        // utils.book_append_sheet(workbook, wsa, "Summary1");
        utils.book_append_sheet(workbook, wsSummary, "Summary", true);
        utils.book_append_sheet(workbook, wsDetailed, "Detail", true);

        let i = 1;
        groups.forEach(group => {
            let ws_group = utils.json_to_sheet(group.data);
            utils.book_append_sheet(workbook, ws_group, "Group " + i + " (" + group.data.length + ")", true);
            i++;
        });

        if (outsideHubs.length > 0) {
            let ws_outsideHub = utils.json_to_sheet(outsideHubs);
            utils.book_append_sheet(workbook, ws_outsideHub, "Outside Hubs", true);
        }

        /* export to XLSX */
        writeFileXLSX(workbook, "SupplierDetailedList.xlsx");
    }

    const handleUnitChange = (event) => {
        setUnit(event.target.value);
    };

    return (


        <div className="edit-panel-container" >

            <div className="edit-panel-column">
                <div className="panel-text">Select Algorith</div>

                <div className="panel-text">
                    <RadioGroup
                        row
                        ref={radioGroupRef}
                        aria-label="ringtone"
                        name="ringtone"
                        value={algorithm}
                        onChange={handleSetAlgorithm}
                    >
                        {algorithmTypes.map((option) => (
                            <FormControlLabel value={option} key={option} control={<Radio />} label={option} />
                        ))}
                    </RadioGroup>
                </div>
            </div>

            {algorithm != 'KMEANS' && <div className="edit-panel-column">
                <div className="panel-text">Select Distance (Miles)</div>

                <div className="panel-text">
                    <RadioGroup
                        row
                        ref={radioGroupRef}
                        aria-label="ringtone"
                        name="ringtone"
                        value={radiusRadio}
                        onChange={handleRadiusRadioChange}
                    >
                        {radiusTypes.map((option) => (
                            <FormControlLabel value={option} key={option} control={<Radio />} label={option} />
                        ))}
                    </RadioGroup>
                </div>
            </div>}

            {algorithm != 'KMEANS' && radiusRadio == ">150" && <div className="edit-panel-column">
                <div className="panel-text">
                    {/* <Slider
                        aria-labelledby="radius-slider-id"
                        value={radius}
                        min={1}
                        step={5}
                        max={150}
                        onChange={handleRadiusChange}
                        valueLabelDisplay="auto"
                    /> */}
                    <TextField
                        id="outlined-number"
                        label="Radius"
                        type="number"
                        size="small"
                        fullWidth
                        // sx={{ width: 60, paddingRight: 1 }}
                        onChange={handleRadiusChange}
                        value={radius}
                    />
                </div>
            </div>}

            <div className="edit-panel-column">
                <div className="panel-text">

                    <TextField
                        id="outlined-number"
                        label="Cluster Size"
                        type="number"
                        size="small"
                        fullWidth
                        // sx={{ width: 60, paddingRight: 1 }}
                        onChange={handleClusterChange}
                        value={clusterSize}
                    />
                </div>
            </div>

            {/* <div className="edit-panel-column">
                <div className="panel-text">Custom Distance Algorithm</div>

                <div className="panel-text">

                    <input label="" type="checkbox" onChange={(e => handleDistChange(e))} checked={checkDist} />

                </div>
            </div> */}




            {/* <TwitterPicker /> */}
            <div className="edit-panel-buttons">
                <Tooltip title="Download Supplier List" arrow >

                    <IconButton color="primary" onClick={downloadSampleFileHandler}
                        sx={{ position: 'absolute', left: '20px' }}>
                        <Download />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Download Detailed Supplier Information" arrow >

                    <IconButton color="primary" onClick={downloadDetailedFileHandler}
                        sx={{ position: 'absolute', left: '50px' }}>
                        <Download />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Apply Algorithm">
                    <IconButton color="primary" aria-label="save" onClick={handleOk}>
                        <Save />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Cancel">
                    <IconButton color="primary" aria-label="delete" size="large" onClick={handleCancel}>
                        <Cancel />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    );
}

CalculationPanel.propTypes = {
    onChangeConfig: PropTypes.func,
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    setConfig: PropTypes.object
};
